import { Link } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';
import { AppChrome } from '@/components/AppChrome';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { useSurfaceAccess } from '@/lib/platform/surfaces';
import { useFiling } from './state';

export function SubmissionPage() {
  const access = useSurfaceAccess(SURFACES['filing-submission']);
  const filingId = useFiling((snapshot) => snapshot.context.filingId);
  if (access === 'waiting') return <p className="p-8 text-sm text-muted-foreground">Checking screen access…</p>;
  if (access === 'unavailable')
    return <p className="p-8 text-sm text-destructive">This screen is unavailable right now.</p>;
  if (access === 'denied')
    return <p className="p-8 text-sm text-muted-foreground">You have no access to this screen.</p>;
  return (
    <AppChrome title="Filing submission" description="Trace approval and transmission for the selected Filing.">
      {!filingId ? (
        <Card>
          <CardContent className="space-y-3 p-6">
            <p className="font-medium">No Filing is open.</p>
            <Button render={<Link to="/filing-setup" />}>Go to Filing setup</Button>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <ArrowUpRight className="size-4 text-primary" />
              IRS transmission
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="font-medium">Submission is unavailable.</p>
            <p className="text-sm text-muted-foreground">
              IRS Modernized e-File transmission and receipt history are not connected in this workspace. TrustFile has
              not claimed that this Filing was approved or submitted.
            </p>
          </CardContent>
        </Card>
      )}
    </AppChrome>
  );
}
